import React from "react";
import {css} from "design";
import {useTheme} from "design/use_theme";
import {
  PoweredByLogo,
  PoweredByLogoDarkMode,
} from '../../images/index'

export const PoweredByFooter = () => {
  const [theme] = useTheme()

  return (
    <a
      href={'https://speakeasy.to'}
      target={'_blank'}
      className={poweredByLogoStyles()} rel="noreferrer"
    >
      {theme.currentTheme === 'light' ? (
        <PoweredByLogo />
      ) : (
        <PoweredByLogoDarkMode />
      )}
    </a>
  )
}

const poweredByLogoStyles = css({
  width: '100%',
  textAlign: 'center',
  verticalAlign: 'middle',
  background: '$grey50',
  padding: '14px 0px 8px',
  pointerEvents: 'auto !important',
  zIndex: 1,

  '&:focus': {
    borderRadius: 0,
  },
})
